/* eslint-disable react/no-array-index-key */
import React, { useEffect, useState, FC } from 'react';
import {
  AccordionSummary,
  AccordionDetails,
  useTheme,
  useMediaQuery,
} from '@mui/material';
import {
  Typography700,
} from 'views/rebranded-module/common/components';
import { LocationCard } from 'views/rebranded-module/common/components/UI/ParticipatingLocations';
import PATHS from 'lib/navigation/paths';
import NavigatorLink from 'views/common/components/Logical/NavigatorLink';
import StyledAccordion from 'views/rebranded-module/common/components/UI/ParticipatingLocations/LocationsGroup/LocationsGroup.styles';
import { RiArrowUpSLine } from 'react-icons/ri';

const LocationsGroup: FC<any> = (props) => {
  const {
    prepareMapUrl,
    handleLocationCardButtonClick,
    target,
    selectedLocationId,
    location,
    searchValue,
    content,
  } = props;
  const theme = useTheme();
  const isTablet = useMediaQuery(theme.breakpoints.up('md'));

  const [expanded, setExpanded] = useState(isTablet);
  const toggleAccordion = () => {
    setExpanded((prev) => !prev);
  };
  useEffect(() => {
    if (searchValue) {
      setExpanded(true);
    } else setExpanded(false);
  }, [searchValue]);
  return (
    <StyledAccordion expanded={isTablet || expanded}>
      <AccordionSummary
        className="LGAccSummary"
        expandIcon={<RiArrowUpSLine className="LGAccIcon" />}
        id={location.name}
        onClick={toggleAccordion}>
        {location.name ? (
          <Typography700
            variant="h5"
            component={NavigatorLink}
            href={PATHS.motorcycleRentalsSlug(location.slug)}
            className="LGGroupTitle">
            {location.name}
          </Typography700>
        ) : (
          <Typography700 variant="h5" className="LGGroupTitle LGGroupOtherLocations">
            {content.otherLocationsTitle}
          </Typography700>
        )}
      </AccordionSummary>
      <AccordionDetails className="LGAccDetails">
        {location.locations.map((item) => (
          <div key={item.id}>
            <LocationCard
              id={item.id}
              address={item.full_address}
              link={prepareMapUrl(item.map_url)}
              title={item.name}
              email={item.email}
              location={PATHS.urlSlugs(item.slug)}
              activeCard={item.activeCard || selectedLocationId === item.id}
              handleLocationCardButtonClick={handleLocationCardButtonClick}
              target={target}
              content={content}
            />
          </div>
        ))}
      </AccordionDetails>
    </StyledAccordion>
  );
};

export { LocationsGroup };